const pagesRoutes = {
  pages: 'pages',
  containers: {
    termsOfService: 'terms-of-service',
    privacyPolicy: 'privacy-policy',
    deleteAccount: 'delete-account',
  },
};

export default pagesRoutes;
